// Sitemap-katalog: alla statiska sidor klassade per kategori så vi kan
// generera index + sub-sitemaps. Dynamiska entries (cases, kunskap, guider,
// audiences, prime) byggs i respektive sub-sitemap-route från innehållskällor.

import type { SitemapEntry } from "./sitemap";
import { EDITORIAL_KEYS, authorPath } from "@/content/editorial";
import { getQuestionSlugs } from "@/lib/aeo/answers";
import { getComparisonSlugs } from "@/lib/seo/comparisons";
import { getPriceGuideSlugs } from "@/lib/seo/priceGuides";



export const CORE_PAGES: SitemapEntry[] = [
  { path: "/", changefreq: "weekly", priority: "1.0" },
  { path: "/alla-sidor", changefreq: "weekly", priority: "0.3" },

  { path: "/tjanster", changefreq: "monthly", priority: "0.9" },
  { path: "/pulse", changefreq: "monthly", priority: "0.95" },
  { path: "/prime", changefreq: "monthly", priority: "0.95" },
  { path: "/pilot", changefreq: "monthly", priority: "0.85" },
  { path: "/brollopsfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/priser", changefreq: "monthly", priority: "0.9" },
  { path: "/process", changefreq: "monthly", priority: "0.7" },
  { path: "/case", changefreq: "weekly", priority: "0.9" },
  { path: "/kunskap", changefreq: "weekly", priority: "0.8" },
  { path: "/guider", changefreq: "weekly", priority: "0.8" },
  { path: "/formatguide-2026", changefreq: "monthly", priority: "0.7" },
  { path: "/for-vem", changefreq: "monthly", priority: "0.7" },
  { path: "/varfor-film", changefreq: "monthly", priority: "0.7" },
  { path: "/faq", changefreq: "monthly", priority: "0.7" },
  { path: "/om-fenny", changefreq: "monthly", priority: "0.6" },
  { path: "/fenny-i-korthet", changefreq: "monthly", priority: "0.6" },
  { path: "/partners", changefreq: "monthly", priority: "0.6" },
  { path: "/press", changefreq: "monthly", priority: "0.8" },
  { path: "/for-journalister", changefreq: "monthly", priority: "0.75" },
  { path: "/redaktionell-policy", changefreq: "yearly", priority: "0.3" },
  { path: "/press/reklamfilm-2026-rapport", changefreq: "yearly", priority: "0.7" },
  { path: "/branschstudier", changefreq: "monthly", priority: "0.85" },
  { path: "/branschstudier/produktfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/branschstudier/prisindex-2026", changefreq: "monthly", priority: "0.85" },
  { path: "/branschstudier/formatbenchmark-2026", changefreq: "monthly", priority: "0.85" },
  { path: "/branschstudier/filmproduktionsbarometern", changefreq: "monthly", priority: "0.85" },
  { path: "/redaktionen", changefreq: "monthly", priority: "0.5" },
  // Författarsidor — en per redaktionsnyckel (E-E-A-T-noder).
  ...EDITORIAL_KEYS.map((k) => ({
    path: authorPath(k),
    changefreq: "monthly" as const,
    priority: "0.4",
  })),
  { path: "/rapport/reklamfilm-2026", changefreq: "yearly", priority: "0.9" },
  { path: "/karriar", changefreq: "monthly", priority: "0.7" },
  { path: "/kontakt", changefreq: "monthly", priority: "0.8" },
  { path: "/ordlista", changefreq: "monthly", priority: "0.6" },
  { path: "/ordlista/filmabonnemang", changefreq: "monthly", priority: "0.7" },
  { path: "/ordlista/pulse-modellen", changefreq: "monthly", priority: "0.7" },
  { path: "/ordlista/premiumfilm-pa-abonnemang", changefreq: "monthly", priority: "0.7" },
  { path: "/integritet", changefreq: "yearly", priority: "0.3" },
  { path: "/jamfor/pulse-vs-prime", changefreq: "monthly", priority: "0.7" },
  { path: "/jamfor/filmbyra-vs-frilansare", changefreq: "monthly", priority: "0.8" },
  { path: "/jamfor/filmbolag-vs-filmbyra", changefreq: "monthly", priority: "0.8" },
  { path: "/jamfor/green-screen-vs-location", changefreq: "monthly", priority: "0.75" },
  { path: "/jamfor/voice-over-vs-ai-rost", changefreq: "monthly", priority: "0.75" },
  { path: "/jamfor/filmabonnemang-vs-projektfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/jamfor/inhouse-vs-filmbyra", changefreq: "monthly", priority: "0.8" },
  { path: "/jamfor/ramavtal-vs-direktupphandling-film", changefreq: "monthly", priority: "0.75" },
  { path: "/jamfor/livesandning-vs-inspelat-webinar", changefreq: "monthly", priority: "0.75" },
  // Jämförelsekluster (drivs av comparisons.ts)
  ...getComparisonSlugs().map(
    (slug): SitemapEntry => ({
      path: `/jamfor/${slug}`,
      changefreq: "monthly",
      priority: "0.8",
    }),
  ),
  { path: "/vad-kostar-en-reklamfilm", changefreq: "monthly", priority: "0.8" },

  { path: "/vad-kostar-en-foretagsfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/hur-lang-ska-en-reklamfilm-vara", changefreq: "monthly", priority: "0.75" },
  { path: "/film-pris-kalkyl", changefreq: "monthly", priority: "0.85" },
  // Priskluster (drivs av priceGuides.ts)
  { path: "/pris", changefreq: "monthly", priority: "0.85" },
  ...getPriceGuideSlugs().map(
    (slug): SitemapEntry => ({
      path: `/pris/${slug}`,
      changefreq: "monthly",
      priority: "0.8",
    }),
  ),


  // AEO-frågekluster (drivs av answers.ts)
  { path: "/fragor", changefreq: "monthly", priority: "0.8" },
  ...getQuestionSlugs("sv").map(
    (slug): SitemapEntry => ({
      path: `/fragor/${slug}`,
      changefreq: "monthly",
      priority: "0.7",
    }),
  ),
];


export const SERVICE_PAGES: SitemapEntry[] = [
  // Pillars / synonymer
  { path: "/reklamfilm", changefreq: "monthly", priority: "0.9" },
  { path: "/filmproduktion", changefreq: "monthly", priority: "0.9" },
  { path: "/videoproduktion", changefreq: "monthly", priority: "0.9" },
  { path: "/foretagsfilm", changefreq: "monthly", priority: "0.9" },
  { path: "/filmbyra", changefreq: "monthly", priority: "0.95" },
  { path: "/filmproducent", changefreq: "monthly", priority: "0.75" },
  // Format
  { path: "/animerad-forklaringsfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/produktfilm", changefreq: "monthly", priority: "0.85" },
  { path: "/sociala-medier-film", changefreq: "monthly", priority: "0.85" },
  { path: "/rekryteringsfilm", changefreq: "monthly", priority: "0.85" },
  { path: "/eventfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/kundcase-film", changefreq: "monthly", priority: "0.85" },
  { path: "/explainer-video", changefreq: "monthly", priority: "0.8" },
  { path: "/dronarfilm", changefreq: "monthly", priority: "0.75" },
  { path: "/dronarfilm/vasteras", changefreq: "monthly", priority: "0.7" },
  { path: "/dronarfilm/gavle", changefreq: "monthly", priority: "0.7" },
  { path: "/dronarfilm/orebro", changefreq: "monthly", priority: "0.7" },
  { path: "/dronarfilm/uppsala", changefreq: "monthly", priority: "0.7" },
  { path: "/varumarkesfilm", changefreq: "monthly", priority: "0.85" },
  { path: "/kampanjfilm", changefreq: "monthly", priority: "0.85" },
  { path: "/dokumentarfilm", changefreq: "monthly", priority: "0.85" },
  { path: "/instruktionsfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/utbildningsfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/internkommunikation-film", changefreq: "monthly", priority: "0.8" },
  { path: "/livesandning", changefreq: "monthly", priority: "0.8" },
  { path: "/massfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/mata-effekt-av-film", changefreq: "monthly", priority: "0.8" },
  { path: "/upphandling-film", changefreq: "monthly", priority: "0.8" },
  { path: "/podcast-video", changefreq: "monthly", priority: "0.8" },
  { path: "/aftermovie", changefreq: "monthly", priority: "0.8" },
  { path: "/testimonial-film", changefreq: "monthly", priority: "0.8" },
  { path: "/employer-branding-film", changefreq: "monthly", priority: "0.85" },
  { path: "/motion-graphics", changefreq: "monthly", priority: "0.85" },
  { path: "/3d-animation", changefreq: "monthly", priority: "0.8" },
  { path: "/3d-produktvisualisering", changefreq: "monthly", priority: "0.85" },

  { path: "/filmbolag", changefreq: "monthly", priority: "0.85" },
  { path: "/filmproduktionsbolag", changefreq: "monthly", priority: "0.85" },
  { path: "/produktionsbolag-film", changefreq: "monthly", priority: "0.8" },
  { path: "/animerad-reklamfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/green-screen", changefreq: "monthly", priority: "0.75" },
  { path: "/voice-over", changefreq: "monthly", priority: "0.75" },
  { path: "/manus-och-koncept", changefreq: "monthly", priority: "0.9" },
  { path: "/manusforfattare", changefreq: "monthly", priority: "0.85" },
  { path: "/reklamfilmsmanus", changefreq: "monthly", priority: "0.85" },
  { path: "/storyboard", changefreq: "monthly", priority: "0.85" },
  { path: "/konceptutveckling-film", changefreq: "monthly", priority: "0.8" },
  { path: "/forproduktion", changefreq: "monthly", priority: "0.8" },
  { path: "/vad-kostar-ett-manus", changefreq: "monthly", priority: "0.8" },
  { path: "/ord-per-minut", changefreq: "monthly", priority: "0.75" },
  { path: "/storytelling-film", changefreq: "monthly", priority: "0.8" },
  { path: "/ai-i-filmproduktion", changefreq: "monthly", priority: "0.8" },
  { path: "/social-media-strategi-film", changefreq: "monthly", priority: "0.8" },
  { path: "/tv-produktion", changefreq: "monthly", priority: "0.85" },
  { path: "/eventfilm/stockholm", changefreq: "monthly", priority: "0.8" },
  { path: "/eventfilm/goteborg", changefreq: "monthly", priority: "0.8" },
  { path: "/eventfilm/malmo", changefreq: "monthly", priority: "0.8" },
  { path: "/jobb", changefreq: "monthly", priority: "0.6" },
  { path: "/praktik", changefreq: "monthly", priority: "0.6" },
  { path: "/b-roll-inspelning", changefreq: "monthly", priority: "0.75" },
  { path: "/casting-skadespelare", changefreq: "monthly", priority: "0.75" },
  { path: "/kortformat-film", changefreq: "monthly", priority: "0.85" },
  { path: "/b2b-video", changefreq: "monthly", priority: "0.9" },

  
  // Kanal-svar
  { path: "/film-for-linkedin", changefreq: "monthly", priority: "0.8" },
  { path: "/film-for-instagram", changefreq: "monthly", priority: "0.8" },
  { path: "/film-for-tiktok", changefreq: "monthly", priority: "0.8" },
  { path: "/film-for-youtube", changefreq: "monthly", priority: "0.8" },
  // Branscher
  { path: "/branscher/saas", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/industri", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/e-handel", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/offentlig-sektor", changefreq: "monthly", priority: "0.75" },
  { path: "/branscher/bygg", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/fastighet", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/halsa", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/restaurang", changefreq: "monthly", priority: "0.75" },
  // Branscher — målgruppsvinkel
  { path: "/branscher/video-for-b2b", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/video-for-tillvaxtbolag", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/video-for-marknadsavdelningar", changefreq: "monthly", priority: "0.8" },
  { path: "/branscher/video-for-saljteam", changefreq: "monthly", priority: "0.8" },
];

export const REGION_HUBS: SitemapEntry[] = [
  { path: "/filmproduktion-sverige", changefreq: "monthly", priority: "0.85" },
  { path: "/videoproduktion-sverige", changefreq: "monthly", priority: "0.85" },
  { path: "/filmproduktion-mellansverige", changefreq: "monthly", priority: "0.8" },
  // Heritage — filmade intervjuer för livsberättelser och kunskapsarv
  { path: "/heritage", changefreq: "monthly", priority: "0.85" },
  { path: "/heritage/livsberattelser", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/kunskapsarv", changefreq: "monthly", priority: "0.8" },
  { path: "/en/heritage", changefreq: "monthly", priority: "0.8" },
  { path: "/en/heritage/livsberattelser", changefreq: "monthly", priority: "0.75" },
  { path: "/en/heritage/kunskapsarv", changefreq: "monthly", priority: "0.75" },
  { path: "/en/heritage/livsberattelse-till-foralder", changefreq: "monthly", priority: "0.7" },
  { path: "/en/heritage/minnesfilm", changefreq: "monthly", priority: "0.7" },
  { path: "/en/heritage/pensionsavgang-kunskapsoverforing", changefreq: "monthly", priority: "0.7" },
  { path: "/en/heritage/tyst-kunskap-dokumentation", changefreq: "monthly", priority: "0.7" },
  // Heritage — ämnessidor (privat + företag)
  { path: "/heritage/livsberattelse-till-foralder", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/slakthistoria-pa-film", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/minnesfilm", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/intervjufragor-livsberattelse", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/generationsskifte-dokumentation", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/pensionsavgang-kunskapsoverforing", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/foretagshistoria-pa-film", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/tyst-kunskap-dokumentation", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/successionsplanering-dokumentation", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/generationsskifte-lantbruk-skog", changefreq: "monthly", priority: "0.8" },
  { path: "/heritage/kompetensinventering", changefreq: "monthly", priority: "0.8" },

  // Still photography is paused; city film pages remain in LOCATION_PAGES below.
];

// Film location pages (non-primary synonyms point to their canonical film pages).

export const LOCATION_PAGES: SitemapEntry[] = [
  { path: "/filmproduktion/stockholm", changefreq: "monthly", priority: "0.9" },
  { path: "/filmproduktion/goteborg", changefreq: "monthly", priority: "0.9" },
  { path: "/filmproduktion/malmo", changefreq: "monthly", priority: "0.85" },
  { path: "/reklamfilm/stockholm", changefreq: "monthly", priority: "0.9" },
  { path: "/reklamfilm/goteborg", changefreq: "monthly", priority: "0.9" },
  { path: "/reklamfilm/malmo", changefreq: "monthly", priority: "0.85" },
  // FEN-010: videoproduktion/<city> + videobyra/<city> canonical:eras till
  // filmproduktion/filmbyra — listas inte i sitemap. produktionsbolag/<city>
  // är sedan FEN-014 självrefererande och listas nedan.
  { path: "/produktionsbolag/stockholm", changefreq: "monthly", priority: "0.85" },
  { path: "/produktionsbolag/goteborg", changefreq: "monthly", priority: "0.85" },
  { path: "/produktionsbolag/malmo", changefreq: "monthly", priority: "0.8" },
  { path: "/animation/stockholm", changefreq: "monthly", priority: "0.85" },
  { path: "/animation/goteborg", changefreq: "monthly", priority: "0.85" },
  { path: "/animation/malmo", changefreq: "monthly", priority: "0.8" },
  // Tier-2 städer
  { path: "/filmproduktion/uppsala", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/linkoping", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/orebro", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/vasteras", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/jonkoping", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/helsingborg", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/umea", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/lund", changefreq: "monthly", priority: "0.8" },
  { path: "/foretagsfilm/uppsala", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/linkoping", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/orebro", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/vasteras", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/jonkoping", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/helsingborg", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/umea", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/lund", changefreq: "monthly", priority: "0.75" },
  // Tier-3 städer
  { path: "/filmproduktion/solna", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/sundsvall", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/karlstad", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/vaxjo", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/halmstad", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/gavle", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/eskilstuna", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/norrkoping", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/boras", changefreq: "monthly", priority: "0.8" },
  { path: "/filmproduktion/lulea", changefreq: "monthly", priority: "0.8" },
  { path: "/foretagsfilm/solna", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/sundsvall", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/karlstad", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/vaxjo", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/halmstad", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/gavle", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/eskilstuna", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/norrkoping", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/boras", changefreq: "monthly", priority: "0.75" },
  { path: "/foretagsfilm/lulea", changefreq: "monthly", priority: "0.75" },
  // Reklamfilm — tier-2
  { path: "/reklamfilm/uppsala", changefreq: "monthly", priority: "0.8" },
  { path: "/reklamfilm/linkoping", changefreq: "monthly", priority: "0.8" },
  { path: "/reklamfilm/orebro", changefreq: "monthly", priority: "0.8" },
  { path: "/reklamfilm/vasteras", changefreq: "monthly", priority: "0.8" },
  { path: "/reklamfilm/jonkoping", changefreq: "monthly", priority: "0.8" },
  { path: "/reklamfilm/helsingborg", changefreq: "monthly", priority: "0.8" },
  { path: "/reklamfilm/umea", changefreq: "monthly", priority: "0.8" },
  { path: "/reklamfilm/lund", changefreq: "monthly", priority: "0.8" },
  // Reklamfilm — tier-3
  { path: "/reklamfilm/solna", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/sundsvall", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/karlstad", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/vaxjo", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/halmstad", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/gavle", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/eskilstuna", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/norrkoping", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/boras", changefreq: "monthly", priority: "0.75" },
  { path: "/reklamfilm/lulea", changefreq: "monthly", priority: "0.75" },
];

// Auto-genererade filmbyra / videobyra / produktionsbolag × 21 städer.
// Datum-källa: src/lib/seo/cities.ts (kanonisk lista).
const HUB_CITIES = [
  "stockholm", "goteborg", "malmo", "uppsala", "linkoping", "orebro",
  "vasteras", "jonkoping", "helsingborg", "umea", "lund", "solna",
  "sundsvall", "karlstad", "vaxjo", "halmstad", "gavle", "eskilstuna",
  "norrkoping", "boras", "lulea",
  // Etapp: nya orter, stadsdelar och närområden (2026).
  "kalmar", "skovde", "trollhattan", "uddevalla", "varberg", "kristianstad",
  "karlskrona", "nykoping", "sodertalje", "falun", "borlange", "ostersund",
  "visby", "skelleftea", "kista", "sundbyberg", "nacka", "taby", "sodermalm",
  "molndal", "hisingen", "lindholmen", "hyllie",
];
const NEW_HUB_CITIES = [
  "kalmar", "skovde", "trollhattan", "uddevalla", "varberg", "kristianstad",
  "karlskrona", "nykoping", "sodertalje", "falun", "borlange", "ostersund",
  "visby", "skelleftea", "kista", "sundbyberg", "nacka", "taby", "sodermalm",
  "molndal", "hisingen", "lindholmen", "hyllie",
];
const TIER1 = new Set(["stockholm", "goteborg", "malmo"]);
// FEN-010: synonymsidor (videobyra, produktionsbolag, videoproduktion) har
// canonical → filmbyra/filmproduktion på ortsnivå, så de ska INTE listas i
// sitemap (annars signalerar vi indexering trots canonical).
// Employer branding-film finns bara för de 21 ursprungliga orterna — de nya
// orterna och stadsdelarna har ingen egen sida och ska därför inte ligga i
// sitemap (annars skickar vi Google på 404).
const EBF_CITIES = HUB_CITIES.filter((slug) => !NEW_HUB_CITIES.includes(slug));
for (const [hub, cities] of [
  ["filmbyra", HUB_CITIES],
  ["employer-branding-film", EBF_CITIES],
] as const) {
  for (const slug of cities) {
    const priority = TIER1.has(slug) ? "0.9" : "0.8";
    const entry = { path: `/${hub}/${slug}`, changefreq: "monthly" as const, priority };
    if (!LOCATION_PAGES.some((p) => p.path === entry.path)) LOCATION_PAGES.push(entry);
  }
}


// Regionsidor (egen sökintention, ingen canonical-flytt).
for (const region of [
  "skane", "vastsverige", "norrland", "smaland", "ostergotland", "dalarna",
]) {
  LOCATION_PAGES.push({
    path: `/filmproduktion-${region}`,
    changefreq: "monthly",
    priority: "0.8",
  });
}

// Nya filmproduktion-ortssidor (befintliga ligger explicit ovan).
for (const slug of NEW_HUB_CITIES) {
  const entry = {
    path: `/filmproduktion/${slug}`,
    changefreq: "monthly" as const,
    priority: "0.75",
  };
  if (!LOCATION_PAGES.some((p) => p.path === entry.path)) LOCATION_PAGES.push(entry);
}

export const EN_PAGES: SitemapEntry[] = [
  { path: "/en", changefreq: "weekly", priority: "1.0" },
  // AEO question cluster (driven by answers.ts)
  { path: "/en/questions", changefreq: "monthly", priority: "0.7" },
  ...getQuestionSlugs("en").map(
    (slug): SitemapEntry => ({
      path: `/en/questions/${slug}`,
      changefreq: "monthly",
      priority: "0.6",
    }),
  ),
  { path: "/en/about", changefreq: "monthly", priority: "0.8" },
  { path: "/en/services", changefreq: "monthly", priority: "0.9" },
  { path: "/en/pricing", changefreq: "monthly", priority: "0.9" },
  { path: "/en/pulse", changefreq: "monthly", priority: "0.9" },
  { path: "/en/prime", changefreq: "monthly", priority: "0.9" },
  { path: "/en/contact", changefreq: "monthly", priority: "0.8" },
  { path: "/en/process", changefreq: "monthly", priority: "0.7" },
  { path: "/en/work", changefreq: "monthly", priority: "0.8" },
  { path: "/en/why-video", changefreq: "monthly", priority: "0.7" },
  { path: "/en/knowledge", changefreq: "weekly", priority: "0.7" },
  { path: "/en/film-production-sweden", changefreq: "monthly", priority: "0.85" },
  { path: "/en/video-agency-stockholm", changefreq: "monthly", priority: "0.85" },
  // Loop 3 — formatsidor
  { path: "/en/commercials", changefreq: "monthly", priority: "0.85" },
  { path: "/en/corporate-video", changefreq: "monthly", priority: "0.85" },
  { path: "/en/brand-film", changefreq: "monthly", priority: "0.85" },
  { path: "/en/product-video", changefreq: "monthly", priority: "0.8" },
  { path: "/en/recruitment-video", changefreq: "monthly", priority: "0.8" },
  { path: "/en/training-video", changefreq: "monthly", priority: "0.75" },
  { path: "/en/event-film", changefreq: "monthly", priority: "0.8" },
  { path: "/en/documentary", changefreq: "monthly", priority: "0.75" },
  { path: "/en/image-film", changefreq: "monthly", priority: "0.8" },
  { path: "/en/campaign-film", changefreq: "monthly", priority: "0.8" },
  { path: "/en/instructional-video", changefreq: "monthly", priority: "0.75" },
  { path: "/en/internal-communication-video", changefreq: "monthly", priority: "0.7" },
  { path: "/en/customer-story-video", changefreq: "monthly", priority: "0.8" },
  { path: "/en/testimonial-video", changefreq: "monthly", priority: "0.8" },
  // Loop 4 — tekniker + kanal-format
  { path: "/en/3d-animation", changefreq: "monthly", priority: "0.8" },
  { path: "/en/motion-graphics", changefreq: "monthly", priority: "0.85" },
  { path: "/en/b-roll", changefreq: "monthly", priority: "0.75" },
  { path: "/en/live-streaming", changefreq: "monthly", priority: "0.8" },
  { path: "/en/aftermovie", changefreq: "monthly", priority: "0.8" },
  { path: "/en/podcast-video", changefreq: "monthly", priority: "0.8" },
  { path: "/en/video-for-instagram", changefreq: "monthly", priority: "0.8" },
  { path: "/en/video-for-linkedin", changefreq: "monthly", priority: "0.8" },
  { path: "/en/video-for-tiktok", changefreq: "monthly", priority: "0.8" },
  { path: "/en/video-for-youtube", changefreq: "monthly", priority: "0.8" },
  { path: "/en/social-media-video", changefreq: "monthly", priority: "0.85" },
  // Loop 5 — tjänsteöversikter + pris/jämför
  { path: "/en/film-production", changefreq: "monthly", priority: "0.9" },
  { path: "/en/video-production", changefreq: "monthly", priority: "0.9" },
  { path: "/en/film-agency", changefreq: "monthly", priority: "0.95" },
  { path: "/en/video-agency", changefreq: "monthly", priority: "0.9" },
  { path: "/en/ad-agency", changefreq: "monthly", priority: "0.9" },
  { path: "/en/content-agency", changefreq: "monthly", priority: "0.85" },
  { path: "/en/film-producer", changefreq: "monthly", priority: "0.75" },
  { path: "/en/employer-branding-video", changefreq: "monthly", priority: "0.85" },
  { path: "/en/video-subscription", changefreq: "monthly", priority: "0.9" },
  { path: "/en/subscription-video", changefreq: "monthly", priority: "0.85" },
  { path: "/en/pulse-vs-prime", changefreq: "monthly", priority: "0.7" },
  { path: "/en/agency-vs-freelancer", changefreq: "monthly", priority: "0.8" },
  { path: "/en/subscription-vs-project", changefreq: "monthly", priority: "0.8" },
  { path: "/en/inhouse-vs-agency", changefreq: "monthly", priority: "0.8" },
  { path: "/en/what-does-a-commercial-cost", changefreq: "monthly", priority: "0.85" },
  { path: "/en/what-does-a-corporate-video-cost", changefreq: "monthly", priority: "0.85" },
  { path: "/en/how-long-should-a-commercial-be", changefreq: "monthly", priority: "0.75" },
  { path: "/en/video-price-calculator", changefreq: "monthly", priority: "0.9" },
  // Loop 6 — industries + misc
  { path: "/en/industries/construction", changefreq: "monthly", priority: "0.8" },
  { path: "/en/industries/ecommerce", changefreq: "monthly", priority: "0.85" },
  { path: "/en/industries/real-estate", changefreq: "monthly", priority: "0.8" },
  { path: "/en/industries/health", changefreq: "monthly", priority: "0.8" },
  { path: "/en/industries/industry", changefreq: "monthly", priority: "0.8" },
  { path: "/en/industries/public-sector", changefreq: "monthly", priority: "0.75" },
  { path: "/en/industries/restaurant", changefreq: "monthly", priority: "0.75" },
  { path: "/en/industries/saas", changefreq: "monthly", priority: "0.85" },
  // EN audience-angle pages (mirror /branscher/video-for-*)
  { path: "/en/video-for-b2b", changefreq: "monthly", priority: "0.8" },
  { path: "/en/video-for-growth-companies", changefreq: "monthly", priority: "0.8" },
  { path: "/en/video-for-marketing-teams", changefreq: "monthly", priority: "0.8" },
  { path: "/en/video-for-sales-teams", changefreq: "monthly", priority: "0.8" },
  { path: "/en/faq", changefreq: "monthly", priority: "0.7" },
  { path: "/en/glossary", changefreq: "monthly", priority: "0.6" },
  { path: "/en/partners", changefreq: "monthly", priority: "0.6" },
  { path: "/en/press", changefreq: "monthly", priority: "0.7" },
  { path: "/en/for-journalists", changefreq: "monthly", priority: "0.7" },
  { path: "/en/privacy", changefreq: "yearly", priority: "0.3" },
  { path: "/en/reports/commercial-2026", changefreq: "yearly", priority: "0.85" },
  { path: "/en/press/commercial-2026-report", changefreq: "yearly", priority: "0.7" },
  // Legacy URLs (redirect targets)
];

export const ALL_STATIC = [
  ...CORE_PAGES,
  ...SERVICE_PAGES,
  ...REGION_HUBS,
  ...LOCATION_PAGES,
  ...EN_PAGES,
];

